(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/use-filtered-tipsinfo-options.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/use-filtered-tipsinfo-options.js');
"use strict";

const {
  useMemo
} = React;
const {
  selectTipsinfo,
  selectResultTipsinfo
} = svs.components.tipsen.selectors;
const {
  selectTipsinfoSupport
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  useSelector
} = ReactRedux;
const {
  tipsinfo
} = svs.components.tipsen.engine.constants;
const useFilteredTipsinfoOptions = isResult => {
  const tipsinfoState = useSelector(selectTipsinfo);
  const resultTipsinfoState = useSelector(selectResultTipsinfo);
  const tipsinfoSupport = useSelector(selectTipsinfoSupport);
  return useMemo(() => {
    const tipsinfoOptions = [];
    const tipsinfoKeyToTitleMapping = {
      [tipsinfo.Odds]: 'Odds',
      [tipsinfo.StartOdds]: 'Startodds',
      [tipsinfo.SvenskaFolket]: 'Svenska folket',
      [tipsinfo.TioTidningar]: 'Tio tidningar',
      [tipsinfo.Matchstart]: 'Matchstart',
      [tipsinfo.Favourites]: 'Favoritskap utifrån odds',
      [tipsinfo.Mutuals]: 'Inbördes möten'
    };
    const tipsinfoKeyToIconMapping = {
      [tipsinfo.Odds]: 'odds',
      [tipsinfo.StartOdds]: 'odds',
      [tipsinfo.SvenskaFolket]: 'players',
      [tipsinfo.TioTidningar]: 'infinity',
      [tipsinfo.Matchstart]: 'clock',
      [tipsinfo.Mutuals]: 'odds'
    };
    const keys = Object.keys(isResult ? resultTipsinfoState : tipsinfoState);
    for (const key of keys) {
      if (tipsinfoSupport[key]) {
        var _tipsinfoKeyToIconMap, _tipsinfoKeyToTitleMa;
        tipsinfoOptions.push({
          isSelected: isResult ? tipsinfoState[key].stateResult : tipsinfoState[key].state,
          icon: (_tipsinfoKeyToIconMap = tipsinfoKeyToIconMapping[key]) !== null && _tipsinfoKeyToIconMap !== void 0 ? _tipsinfoKeyToIconMap : 'odds',
          key,
          title: (_tipsinfoKeyToTitleMa = tipsinfoKeyToTitleMapping[key]) !== null && _tipsinfoKeyToTitleMa !== void 0 ? _tipsinfoKeyToTitleMa : ''
        });
      }
    }
    const indexOfMutuals = tipsinfoOptions.findIndex(tipsInfo => tipsInfo.key === tipsinfo.Mutuals);
    if (indexOfMutuals >= 0) {
      tipsinfoOptions.splice(indexOfMutuals);
    }
    return tipsinfoOptions;
  }, [tipsinfoState, resultTipsinfoState, tipsinfoSupport, isResult]);
};
setGlobal('svs.components.tipsen.tipsinfo.useFilteredTipsinfoOptions', useFilteredTipsinfoOptions);

 })(window);